import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AppStateService } from '../services/app-state.service';

/**
 * Guard to validate step navigation in the check-in process
 * Prevents users from accessing steps without completing previous steps
 */
@Injectable({
  providedIn: 'root'
})
export class StepGuard implements CanActivate {
  constructor(
    private router: Router,
    private appState: AppStateService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const targetStep = this.getStepFromRoute(route.routeConfig?.path || '');

    // Once complete-daily-checkin has succeeded, /credit is off-limits (going back there
    // and resubmitting would duplicate gastro master cards) - always redirect to /send instead.
    if (targetStep === 3 && this.appState.dailyCheckinCompleted) {
      this.router.navigate(['/send']);
      return false;
    }

    // Allow navigation if target step is 1 (always accessible) or lower than current step
    if (targetStep === 1 || targetStep <= this.appState.currentStep) {
      return true;
    }

    // Otherwise, redirect to current step
    this.router.navigate([this.getRouteForStep(this.appState.currentStep)]);
    return false;
  }

  private getStepFromRoute(routePath: string): number {
    switch (routePath) {
      case '':
      case 'search':
        return 1;
      case 'verify':
        return 2;
      case 'credit':
        return 3;
      case 'send':
        return 4;
      default:
        return 1;
    }
  }

  private getRouteForStep(step: number): string {
    switch (step) {
      case 1:
        return '';
      case 2:
        return 'verify';
      case 3:
        return 'credit';
      case 4:
        return 'send';
      default:
        return '';
    }
  }
}
